// import {useState} from 'react';
import {isMobile} from "react-device-detect";
import {useLocation, useNavigate} from "react-router-dom";

import Fab from '@mui/material/Fab';

import Skeleton from '@mui/material/Skeleton';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import ShoppingCardButton from '../../../Content/Widgets/NodeActions/Buttons/ShoppingCardButton';

import {useShoppingStore} from '../../../../Stores/shopping';
import {useNavigationStore} from '../../../../Stores/navigation';
import {useGlobalCustomContext} from '../../../../Helpers/context';

import './index.scss'

export default function ProfileActions(props) {
    const {hideProfile} = props;

    const {cart} = useShoppingStore();

    const navigate = useNavigate();

    const {contentLoading} = useNavigationStore();
    const {userState} = useGlobalCustomContext();

    if (userState?.userLoginInProgress) return <div className='actionsList'>
        <div className='actionsListButtons'>
            <Skeleton variant="rectangular" width={56} height={56} style={{
                borderRadius: '15px',
                display: 'inline-flex',
                marginLeft: '0.5rem'
            }} />
        </div>
    </div>

    const goHome = () => {
        navigate('/')
    }

    const goProfile = () => {
        navigate('/profile')
    }

    return <div className='actionsList'>
        <div className='actionsListButtons'>
            <div className="left">
                <div className="block">
                    {isMobile && <Fab
                        // color="neutral"
                        onClick={goHome}>
                            <HomeOutlinedIcon />
                    </Fab>}
                    {isMobile && !hideProfile && <Fab
                        // color="neutral"
                        onClick={goProfile}>
                            <PersonOutlineIcon />
                    </Fab>}
                </div>
            </div>

            <div className="right">
                {cart?.length > 0 && <div className="block"><ShoppingCardButton disabled={contentLoading} /></div>}
            </div>
        </div>
    </div>
}
